import { isValidElement } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';
import { EmptyStateCTA, EmptyStateCTAProps } from './EmptyStateCTA';

export type EmptyStateProps = React.PropsWithChildren<{
  icon?: IconProp;
  customIcon?: {
    icon?: React.FC<React.SVGProps<SVGSVGElement>>;
    className?: string;
  };
  captionLine1: string;
  captionLine2?: string | JSX.Element;
  CTA?: EmptyStateCTAProps;
}>;

export const EmptyState = ({
  customIcon,
  icon,
  captionLine1,
  captionLine2,
  CTA,
  children,
}: EmptyStateProps) => (
  <div className="flex items-center flex-col gap-4 text-[#8F94A1]">
    {customIcon?.icon ? (
      <customIcon.icon
        className={`${customIcon?.className ? customIcon.className : ''}`}
      />
    ) : icon ? (
      <FontAwesomeIcon icon={icon} size="4x" />
    ) : null}
    <Typography variant="h6">{captionLine1}</Typography>
    {children}
    <div className="flex items-baseline gap-1">
      {isValidElement(captionLine2) ? (
        <>{captionLine2}</>
      ) : captionLine2 ? (
        <Typography variant="body2">{captionLine2}</Typography>
      ) : null}
      {CTA && <EmptyStateCTA {...CTA} />}
    </div>
  </div>
);
